import { isOneOfEnumControl, rankWith } from "@jsonforms/core";

export default rankWith(4, isOneOfEnumControl);
